import { useParams, useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Swal from 'sweetalert2';
import { Modal, Spinner, Offcanvas, Form } from 'react-bootstrap';


const SettingsDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [companySettings, setCompanySettings] = useState(null);
    const [termsDetails, setTermsDetails] = useState([]);

    // Read tab from query param
    const queryParams = new URLSearchParams(location.search);
    const tabParam = queryParams.get('tab');

    const [activeTab, setActiveTab] = useState(tabParam || 'termInfo');
    const [selectedType, setSelectedType] = useState('quotation');
    const [currentTermId, setCurrentTermId] = useState(null);
    const [activeTaxTab, setActiveTaxTab] = useState(null);
    const [taxDetails, setTaxDetails] = useState([]);
    const [countries, setCurrency] = useState('');
    const [clientType, setClientType] = useState('export');


    const [formData, setFormData] = useState({
        subject: '',
        value: '',
        company_name: '',
        vat_number: '',
        email: '',
        phone: '',
        company_address: '',
        country: '',
        company_info: '',
        ZipCode: '',
        currency: '',
        mail_mailer: '',
        mail_host: '',
        mail_encryption: '',
        mail_username: '',
        mail_password: '',
        mail_port: '',
        mail_from_address: '',
        mail_from_name: '',
        start_fmonth: '',
        end_fmonth: '',
        value_export: '',
        value_local: '',
        disclaimer: '',
        working_days: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat'], // Default UAE working days




    });

    const didFetchRef = useRef(false);

    const fetchTermsDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/quotationterm`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            setTermsDetails(response.data.quotation_terms.data);
        } catch (error) {
            console.error('Error fetching quotation terms:', error);
        }
    };
    const fetchCountries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/countries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,
            });

            let countryList = response.data.Data;

            // Ensure country with ID 231 (AED) appears first

            setCurrency(countryList);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };

    const handleClientTypeChange = (type) => {
        setClientType(type);
    };

    // Get current content based on selected client type
    const getCurrentContent = () => {
        switch (clientType) {
            case 'export':
                return formData.value_export || '';
            case 'local':
                return formData.value_local || '';
            default:
                return formData.value || '';
        }
    };

    // Handle content change based on client type
    const handleEditorChange = (content) => {
        setFormData((prev) => {
            let updatedData = { ...prev };

            switch (clientType) {
                case 'export':
                    updatedData.value_export = content;
                    break;
                case 'local':
                    updatedData.value_local = content;
                    break;
                default:
                    updatedData.value = content;
            }

            saveFormDataToLocalStorage(updatedData);
            return updatedData;
        });
    };

    // Handle disclaimer change
    const handleDisclaimerChange = (content) => {
        setFormData((prev) => {
            const updatedData = {
                ...prev,
                disclaimer: content
            };
            saveFormDataToLocalStorage(updatedData);
            return updatedData;
        });
    };


    const fetchTaxDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/settings/tax`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const taxData = response.data.setting;

            // ✅ Set the data
            setTaxDetails(taxData);

            // ✅ Also populate formData
            setFormData({
                q1_start_month: taxData?.q1_start_month || 'January' || '',
                q1_end_month: taxData?.q1_end_month || 'March' || '',
                q1_due_date: taxData?.q1_due_date || '',

                q2_start_month: taxData?.q2_start_month || 'April' || '',
                q2_end_month: taxData?.q2_end_month || 'June' || '',
                q2_due_date: taxData?.q2_due_date || '',

                q3_start_month: taxData?.q3_start_month || 'July' || '',
                q3_end_month: taxData?.q3_end_month || 'September' || '',
                q3_due_date: taxData?.q3_due_date || '',

                q4_start_month: taxData?.q4_start_month || 'October' || '',
                q4_end_month: taxData?.q4_end_month || 'December' || '',
                q4_due_date: taxData?.q4_due_date || '',

                start_month: taxData?.start_month || 'January' || '',
                end_month: taxData?.end_month || 'December' || '',
                due_date: taxData?.due_date || ''
            });
        } catch (error) {
            console.error('Error fetching quotation terms:', error);
        }
    };
    const getAssetUrl = (path) => {
        if (!path) return null;
        if (path.startsWith('http')) return path;
        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        return `${backendUrl}/storage/${path}`;
    };

    const fetchCompanySettings = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/settings`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            let working_days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat']; // Default

            if (response.data.setting.working_days) {
                if (typeof response.data.setting.working_days === 'string') {
                    try {
                        working_days = JSON.parse(response.data.setting.working_days);
                    } catch (e) {
                        // If parsing fails, try to split by comma
                        working_days = response.data.setting.working_days.split(',')
                            .map(day => day.trim())
                            .filter(day => day);
                    }
                } else if (Array.isArray(response.data.setting.working_days)) {
                    working_days = response.data.setting.working_days;
                }
            }

            // Ensure working_days is always an array
            if (!Array.isArray(working_days)) {
                working_days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
            }
            let start_fmonth = '', end_fmonth = '';
            if (response.data.setting.financial_year) {
                const financialYearRaw = response.data.setting.financial_year || '';
                const financialYear = financialYearRaw.split(' -'); // Fix for hyphen
                start_fmonth = financialYear[0]?.trim() || '';
                end_fmonth = financialYear[1]?.trim() || '';
            }
            const fetchedData = {
                company_name: response.data.setting.company_name || '',
                vat_number: response.data.setting.vat_number || '',
                email: response.data.setting.email || '',
                phone: response.data.setting.phone || '',
                company_address: response.data.setting.company_address || '',
                country: response.data.setting.country || '',
                company_info: response.data.setting.company_info || '',
                ZipCode: response.data.setting.ZipCode || '',
                currency: response.data.setting.currency || '',
                financial_year: response.data.setting.financial_year || '',
                working_days: working_days,
                start_fmonth,
                end_fmonth,
                q1_start_month: response.data.setting?.q1_start_month,
                q1_end_month: response.data.setting?.q1_end_month,
                q2_start_month: response.data.setting?.q2_start_month,
                q2_end_month: response.data.setting.q2_end_month,
                q3_start_month: response.data.setting.q3_start_month,
                q3_end_month: response.data.setting.q3_end_month,
                q4_start_month: response.data.setting.q4_start_month,
                q4_end_month: response.data.setting.q4_end_month,
                start_month: response.data.setting.start_month,
                end_month: response.data.setting.end_month,
                q1_due_date: response.data.setting.q1_due_date,
                q2_due_date: response.data.setting.q2_due_date,
                q3_due_date: response.data.setting.q3_due_date,
                q4_due_date: response.data.setting.q4_due_date,
                due_date: response.data.setting.due_date,
                icon: response.data.setting.icon ? getAssetUrl(response.data.setting.icon) : null,
                logo: response.data.setting.logo ? getAssetUrl(response.data.setting.logo) : null,


            };

            localStorage.setItem('formData', JSON.stringify(fetchedData));
            setFormData(fetchedData);


        } catch (error) {
            console.error('Error fetching company settings:', error);
        }
    };
    const fetchSmtpSettings = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/settings/mail`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const fetchedData = {
                mail_mailer: response.data.smtp.mail_mailer || '',
                mail_host: response.data.smtp.mail_host || '',
                mail_encryption: response.data.smtp.mail_encryption || '',
                mail_username: response.data.smtp.mail_username || '',
                mail_password: response.data.smtp.mail_password || '',
                mail_port: response.data.smtp.mail_port || '',
                mail_from_address: response.data.smtp.mail_from_address || '',
                mail_from_name: response.data.smtp.mail_from_name || '',

            };

            localStorage.setItem('smtp', JSON.stringify(fetchedData));
            setFormData(fetchedData);
        } catch (error) {
            console.error('Error fetching company settings:', error);
        }
    };
    useEffect(() => {
        if (activeTab === 'termInfo') {
            fetchTermsDetails();
        }
    }, [activeTab]);
    useEffect(() => {
        if (activeTab === 'taxSettings') {
            fetchTaxDetails();
        }
    }, [activeTab]);

    useEffect(() => {
        if (activeTab === 'companyInfo' && !formData.company_name) {
            fetchCompanySettings();
            fetchCountries();
        }
        if (activeTab === 'smtpSettings') {
            fetchSmtpSettings();
        }

    }, [activeTab]);

    const saveFormDataToLocalStorage = (data) => {
        const updatedData = { ...formData, ...data };
        localStorage.setItem('formData', JSON.stringify(updatedData));
    };

    const loadFormDataFromLocalStorage = () => {
        const savedFormData = JSON.parse(localStorage.getItem('formData') || '{}');
        setFormData((prev) => ({
            ...prev,
            ...savedFormData,
        }));
    };

    useEffect(() => {
        const savedData = JSON.parse(localStorage.getItem('formData') || '{}');
        if (Object.keys(savedData).length > 0) {
            setFormData(savedData);
        } else {
            fetchCompanySettings();
        }
    }, []);

    useEffect(() => {
        if (termsDetails && selectedType) {
            const term = termsDetails.find((item) => item.type === selectedType);
            if (term) {
                setCurrentTermId(term?.id || null);
                setFormData({
                    subject: term?.subject || '',
                    value: term?.value || '',
                });
            }
        }
    }, [termsDetails, selectedType]);

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        const newParams = new URLSearchParams(location.search);
        newParams.set('tab', tab);
        navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    };
    const getNextMonth = (startMonth, offset) => {
        const index = months.indexOf(startMonth);
        return months[(index + offset) % 12];
    };


    const handleTaxChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => {
            const updated = { ...prev, [name]: value };

            // If q1_start_month is changed, set the next quarters
            if (name === 'q1_start_month' && value) {
                const q1_start = value;
                updated.q1_end_month = getNextMonth(q1_start, 2);
                updated.q2_start_month = getNextMonth(q1_start, 3);
                updated.q2_end_month = getNextMonth(q1_start, 5);
                updated.q3_start_month = getNextMonth(q1_start, 6);
                updated.q3_end_month = getNextMonth(q1_start, 8);
                updated.q4_start_month = getNextMonth(q1_start, 9);
                updated.q4_end_month = getNextMonth(q1_start, 11);
            }

            return updated;
        });
    };


    const handleDateChange = (name, date) => {
        const [taxType, field] = name.split('.');

        setFormData(prev => ({
            ...prev,
            tax_settings: {
                ...prev?.tax_settings,
                [taxType]: {
                    ...prev?.tax_settings[taxType],
                    [field]: date
                }
            }
        }));
    };
    const handleRadioChange = (type) => {
        setSelectedType(type);
        const term = termsDetails.find((item) => item.type === type);
        setCurrentTermId(term?.id || null);
        setFormData({
            subject: term?.subject || '',
            value: term?.value || '',
        });
    };

    const handleSubjectChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => {
            const updated = {
                ...prev,
                [name]: value,
                // Ensure working_days is always defined
                working_days: prev.working_days || ['mon', 'tue', 'wed', 'thu', 'fri', 'sat']
            };
            saveFormDataToLocalStorage(updated);
            return updated;
        });
    };
    function getFinancialYear(startMonth, endMonth) {
        const monthIndex = {
            January: 0, February: 1, March: 2, April: 3, May: 4, June: 5,
            July: 6, August: 7, September: 8, October: 9, November: 10, December: 11
        };

        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth(); // 0 = Jan, 1 = Feb, ...

        const startMonthIndex = monthIndex[startMonth];
        const endMonthIndex = monthIndex[endMonth];

        let startYear = currentYear;
        let endYear = currentYear;

        // Check if the endMonth is after the startMonth, in which case endYear should be next year
        if (startMonthIndex <= endMonthIndex) {
            // If the fiscal year does not span over a calendar year
            endYear = currentYear;
        } else {
            // If the fiscal year spans over a calendar year (e.g., March 2025 - February 2026)
            endYear = currentYear + 1;
        }

        // Log the calculated years for debugging
        console.log(`Calculated Start Year: ${startYear}`);
        console.log(`Calculated End Year: ${endYear}`);
        // Return the fiscal year in "startMonth-endMonth" format (e.g., "April-March")
        return `${startMonth} - ${endMonth}`;
    }

    // const handleEditorChange = (content) => {
    //     setFormData((prev) => {
    //         const updatedData = { ...prev, value: content };
    //         saveFormDataToLocalStorage(updatedData);
    //         return updatedData;
    //     });
    // };
    const months = [
        'January', 'February', 'March',
        'April', 'May', 'June',
        'July', 'August', 'September',
        'October', 'November', 'December'
    ];
    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check file type
            if (!file.type.match('image.*')) {
                alert('Please select an image file (JPG, PNG, GIF)');
                return;
            }

            // Check file size (max 2MB)
            if (file.size > 2 * 1024 * 1024) {
                alert('File size should be less than 2MB');
                return;
            }

            // Create preview and prepare for upload
            const reader = new FileReader();
            reader.onload = (event) => {
                // For immediate preview
                setFormData(prev => ({
                    ...prev,
                    logo: event.target.result,
                    logo_file: file // Keep the file object for upload
                }));
            };
            reader.readAsDataURL(file);
        }
    };
    // const handleSaveCompanySettings = async () => {
    //     try {
    //         const backendUrl = process.env.REACT_APP_BACKEND_URL;
    //         const userInfo = JSON.parse(localStorage.getItem('user-info'));
    //         const origin = localStorage.getItem('user-origin');
    //         const token = userInfo?.token;
    //         const financialYear = getFinancialYear(formData.start_fmonth, formData.end_fmonth);
    //         const payload = {
    //             ...formData, financial_year: financialYear,

    //         };

    //         await axios.post(`${backendUrl}/api/settings`, payload, {
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //                 'Tenant-Origin': origin,
    //             },
    //         });

    //         showSuccessToast('Company Information updated successfully!');
    //         saveFormDataToLocalStorage({
    //             ...formData,
    //             financial_year: financialYear, // Save the version with years for local storage
    //         });
    //     } catch (error) {
    //         console.error('Error saving company settings:', error);
    //     }
    // };

    const handleIconUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check file type
            if (!file.type.match('image.*')) {
                alert('Please select an image file (JPG, PNG, GIF, ICO)');
                return;
            }

            // Check file size (max 2MB)
            if (file.size > 2 * 1024 * 1024) {
                alert('File size should be less than 2MB');
                return;
            }

            // Create preview and prepare for upload
            const reader = new FileReader();
            reader.onload = (event) => {
                setFormData(prev => ({
                    ...prev,
                    icon: event.target.result,
                    icon_file: file // Keep the file object for upload
                }));
            };
            reader.readAsDataURL(file);
        }
    };
    const handleSaveCompanySettings = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const financialYear = getFinancialYear(formData.start_fmonth, formData.end_fmonth);

            const formDataToSend = new FormData();
            const workingDaysToSend = formData.working_days || ['mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

            console.log('Working days being sent:', workingDaysToSend);
            console.log('Working days type:', typeof workingDaysToSend);

            // Append all fields
            Object.keys(formData).forEach(key => {
                if (key === 'logo_file' && formData.logo_file) {
                    formDataToSend.append('logo', formData.logo_file);
                } else if (key === 'icon_file' && formData.icon_file) {
                    formDataToSend.append('icon', formData.icon_file);
                }
                else if (key === 'working_days') {
                    // Always send working_days as comma-separated string
                    if (Array.isArray(workingDaysToSend)) {
                        formDataToSend.append('working_days', workingDaysToSend.join(','));
                    } else if (workingDaysToSend) {
                        formDataToSend.append('working_days', workingDaysToSend);
                    }
                } else if (key !== 'logo_file' && key !== 'icon_file' && key !== 'logo' && key !== 'icon' && formData[key] !== null && formData[key] !== undefined) {
                    formDataToSend.append(key, formData[key]);
                }
            });
            if (!formDataToSend.has('working_days')) {
                formDataToSend.append('working_days', workingDaysToSend.join(','));
            }

            formDataToSend.append('financial_year', financialYear);
            console.log('Working days being sent:', formData.working_days);
            console.log('Working days type:', typeof formData.working_days);

            // Use PUT if you're updating existing settings, POST for creating new
            const method = formData.id ? 'put' : 'post';
            const url = formData.id ? `${backendUrl}/api/settings/${formData.id}` : `${backendUrl}/api/settings`;

            await axios[method](url, formDataToSend, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                    'Content-Type': 'multipart/form-data',
                },
            });

            showSuccessToast('Company Information updated successfully!');

            // Prepare data for localStorage (remove file object)
            const storageData = { ...formData, financial_year: financialYear, working_days: workingDaysToSend };
            delete storageData.logo_file;
            delete storageData.icon_file;

            saveFormDataToLocalStorage(storageData);

        } catch (error) {
            console.error('Error saving company settings:', error);
            showErrorToast('Failed to update company information!');
        }
    };
    const handleSaveTaxSettings = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const payload = {
                ...formData

            };

            await axios.post(`${backendUrl}/api/settings/tax`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            showSuccessToast('Company Information updated successfully!');
            saveFormDataToLocalStorage(formData);
        } catch (error) {
            console.error('Error saving company settings:', error);
        }
    };
    const handleSaveTerm = async () => {
        if (!currentTermId) {
            showErrorToast('No term selected for update!');
            return;
        }

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const payload = {
                subject: formData.subject,
                value: formData.value,
                value_export: formData.value_export,
                value_local: formData.value_local,
                disclaimer: formData.disclaimer,
            };

            await axios.put(`${backendUrl}/api/quotationterm/${currentTermId}`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            showSuccessToast('Term updated successfully!');
        } catch (error) {
            console.error('Error updating term:', error);
        }
    };
    useEffect(() => {
        if (termsDetails && selectedType) {
            const term = termsDetails.find((item) => item.type === selectedType);
            if (term) {
                setCurrentTermId(term?.id || null);
                setFormData(prev => ({
                    ...prev,
                    subject: term?.subject || '',
                    value: term?.value || '',
                    value_export: term?.value_export || '',
                    value_local: term?.value_local || '',
                    disclaimer: term?.disclaimer || '',
                }));
            } else {
                // If no term exists for this type, reset the fields but keep other form data
                setCurrentTermId(null);
                setFormData(prev => ({
                    ...prev,
                    subject: '',
                    value: '',
                    value_export: '',
                    value_local: '',
                    disclaimer: '',
                }));
            }
        }
    }, [termsDetails, selectedType]);


    const showSuccessToast = (message) => {
        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: message,
            timer: 3000,
            timerProgressBar: false,
            showConfirmButton: false,
            didOpen: () => {
                const container = Swal.getContainer();
                container.style.top = '50px';
            },
        });
    };

    const showErrorToast = (message) => {
        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: message,
            timer: 3000,
            timerProgressBar: false,
            showConfirmButton: false,
            didOpen: () => {
                const container = Swal.getContainer();
                container.style.top = '50px';
            },
        });
    };
    const handleSaveSettings = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const smtpPayload = {
                mail_mailer: formData.mail_mailer,
                mail_host: formData.mail_host,
                mail_encryption: formData.mail_encryption,
                mail_port: formData.mail_port,
                mail_username: formData.mail_username,
                mail_password: formData.mail_password,
                mail_from_address: formData.mail_from_address,
                mail_from_name: formData.mail_from_name,

            };

            await axios.post(`${backendUrl}/api/settings/mail`, smtpPayload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            showSuccessToast('SMTP updated successfully!');
        } catch (error) {
            console.error('Error saving settings:', error);
        }
    };
    useEffect(() => {
        const defaultVat = {
            q1_start_month: 'January',
            q1_end_month: 'March',
            q2_start_month: 'April',
            q2_end_month: 'June',
            q3_start_month: 'July',
            q3_end_month: 'September',
            q4_start_month: 'October',
            q4_end_month: 'December',
        };

        const defaultCorporate = {
            start_month: 'January',
            end_month: 'December',
        };

        setFormData(prev => {
            const updated = { ...prev };

            // Apply default VAT values if not already present
            for (const key in defaultVat) {
                if (!updated[key]) {
                    updated[key] = defaultVat[key];
                }
            }

            // Apply default Corporate Tax values if not already present
            for (const key in defaultCorporate) {
                if (!updated[key]) {
                    updated[key] = defaultCorporate[key];
                }
            }

            return updated;
        });
    }, []);

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">Settings</h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-3">
                            <div className="card settings-nav-card">
                                <div className="card-body p-0">
                                    <div className="nav flex-column nav-pills term-pills">
                                        <button
                                            onClick={() => handleTabClick('termInfo')}
                                            className={`nav-link term-link text-start d-flex align-items-center ${activeTab === 'termInfo' ? 'active' : ''
                                                }`}
                                        >
                                            <span className="nav-icon term-icon">
                                                <i className="bx bx-file"></i>
                                            </span>
                                            <div>
                                                <h6>Document Templates</h6>
                                                <p>Manage terms & conditions</p>
                                            </div>
                                        </button>
                                        <button
                                            onClick={() => handleTabClick('companyInfo')}
                                            className={`nav-link term-link text-start d-flex align-items-center ${activeTab === 'companyInfo' ? 'active' : ''
                                                }`}
                                        >
                                            <span className="nav-icon term-icon">
                                                <i className="bx bx-buildings"></i>
                                            </span>
                                            <div>
                                                <h6>Company Profile</h6>
                                                <p>Update business details</p>
                                            </div>
                                        </button>
                                        <button
                                            onClick={() => handleTabClick('taxSettings')}
                                            className={`nav-link term-link text-start d-flex align-items-center ${activeTab === 'taxSettings' ? 'active' : ''}`}
                                        >
                                            <span className="nav-icon term-icon">
                                                <i className="bx bx-calculator"></i>
                                            </span>
                                            <div>
                                                <h6>Tax Settings</h6>
                                                <p>Configure tax deadlines</p>
                                            </div>
                                        </button>
                                        <button
                                            onClick={() => handleTabClick('smtpSettings')}
                                            className={`nav-link term-link text-start d-flex align-items-center ${activeTab === 'smtpSettings' ? 'active' : ''}`}
                                        >
                                            <span className="nav-icon term-icon">
                                                <i className="bx bx-mail-send"></i>
                                            </span>
                                            <div>
                                                <h6>SMTP Settings</h6>
                                                <p>Configure email settings</p>
                                            </div>
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-9">
                            <div className="card form-card">
                                <div className="card-body p-4">

                                    {activeTab === 'termInfo' && (
                                        <div className="template-settings">
                                            <div className="d-flex justify-content-between align-items-center mb-4">
                                                <h4 className="form-title">Document Templates</h4><br />
                                                <div className="template-type-selector">
                                                    {['quotation', 'purchase_order', 'proforma_invoice', 'tax_invoice'].map((type) => (
                                                        <button
                                                            key={type}
                                                            className={`template-type-btn ${selectedType === type ? 'active' : ''}`}
                                                            onClick={() => handleRadioChange(type)}
                                                        >
                                                            {type.replace('_', ' ')}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div><br />

                                            {/* Client Type Selector */}
                                            <div className="form-section mb-4">
                                                <h5 className="section-title">
                                                    <i className="bx bx-group"></i> Client Type Settings
                                                </h5>
                                                <div className="client-type-selector">
                                                    <label className="form-label1 mb-3">Select Client Type to Edit Terms:</label>
                                                    <div className="btn-group w-100">

                                                        <button
                                                            type="button"
                                                            className={`btn ${clientType === 'export' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                            onClick={() => handleClientTypeChange('export')}
                                                        >
                                                            <i className="bx bx-plane"></i> Export Clients
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className={`btn ${clientType === 'local' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                            onClick={() => handleClientTypeChange('local')}
                                                        >
                                                            <i className="bx bx-buildings"></i> UAE Local Clients
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="form-group floating-label">
                                                <input
                                                    type="text"
                                                    id="templateTitle"
                                                    className="form-control floating-input"
                                                    name="subject"
                                                    value={formData.subject}
                                                    onChange={handleSubjectChange}
                                                    placeholder=" "
                                                />
                                                <label htmlFor="templateTitle">Template Title</label>
                                            </div>

                                            {/* Main Content Editor */}
                                            <div className="form-section">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <label className="form-label1">
                                                        Terms & Conditions Content
                                                        {clientType !== 'default' && (
                                                            <span className="badge bg-info ms-2">
                                                                {clientType === 'export' ? 'Export Clients' : 'UAE Local Clients'}
                                                            </span>
                                                        )}
                                                    </label>
                                                </div>
                                                <div className="editor-container">
                                                    <ReactQuill
                                                        value={getCurrentContent()}
                                                        onChange={handleEditorChange}
                                                        theme="snow"
                                                        modules={{
                                                            toolbar: [
                                                                [{ header: [1, 2, false] }],
                                                                ['bold', 'italic', 'underline', 'strike'],
                                                                [{ list: 'ordered' }, { list: 'bullet' }],
                                                                ['link', 'image'],
                                                                ['clean'],
                                                            ],
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            {/* Disclaimer Editor - Common for all client types */}
                                            <div className="form-section mt-4">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <label className="form-label1">
                                                        Disclaimer (Applies to all client types)
                                                    </label>
                                                    <span className="badge bg-secondary">Global</span>
                                                </div>
                                                <div className="editor-container">
                                                    <ReactQuill
                                                        value={formData.disclaimer || ''}
                                                        onChange={handleDisclaimerChange}
                                                        theme="snow"
                                                        modules={{
                                                            toolbar: [
                                                                [{ header: [1, 2, false] }],
                                                                ['bold', 'italic', 'underline', 'strike'],
                                                                [{ list: 'ordered' }, { list: 'bullet' }],
                                                                ['link'],
                                                                ['clean'],
                                                            ],
                                                        }}
                                                    />
                                                </div>
                                                <small className="form-text text-muted">
                                                    This disclaimer will be displayed at the bottom of all documents regardless of client type
                                                </small>
                                            </div>



                                            <div className="form-actions mt-4">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-save"
                                                    onClick={handleSaveTerm}
                                                >
                                                    <i className="bx bx-save"></i> Save
                                                </button>

                                            </div>
                                        </div>
                                    )}


                                    {activeTab === 'companyInfo' && (
                                        <div className="company-settings">
                                            <h5 className="form-title">Company Profile</h5><br />

                                            {/* Logo Upload Section - ADDED */}
                                            <div className="form-section">
                                                <h5 className="section-title">
                                                    <i className="bx bx-image"></i> Company Branding
                                                </h5>
                                                <div className="row">
                                                    {/* Logo Upload */}
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="form-label1">Upload Company Logo</label>
                                                            <input
                                                                type="file"
                                                                className="form-control"
                                                                accept="image/*"
                                                                onChange={handleLogoUpload}
                                                            />
                                                            <small className="form-text text-muted">
                                                                Recommended size: 200x80px. Supported formats: JPG, PNG, GIF, SVG
                                                            </small>
                                                        </div>
                                                        {formData.logo && (
                                                            <div className="logo-preview mt-2">
                                                                <p className="form-label1">Logo Preview:</p>
                                                                <img
                                                                    src={formData.logo}
                                                                    alt="Company Logo Preview"
                                                                    style={{
                                                                        maxWidth: '200px',
                                                                        maxHeight: '80px',
                                                                        border: '1px solid #ddd',
                                                                        padding: '5px',
                                                                        backgroundColor: '#f8f9fa'
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Icon Upload */}
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="form-label1">Upload Website Icon (Favicon)</label>
                                                            <input
                                                                type="file"
                                                                className="form-control"
                                                                accept="image/*,.ico"
                                                                onChange={handleIconUpload}
                                                            />
                                                            <small className="form-text text-muted">
                                                                Recommended: 32x32px or 64x64px. Formats: PNG, JPG, ICO, GIF
                                                            </small>
                                                        </div>
                                                        {formData.icon && (
                                                            <div className="icon-preview mt-2">
                                                                <p className="form-label1">Icon Preview:</p>
                                                                <img
                                                                    src={formData.icon}
                                                                    alt="Website Icon Preview"
                                                                    style={{
                                                                        width: '32px',
                                                                        height: '32px',
                                                                        border: '1px solid #ddd',
                                                                        padding: '5px',
                                                                        backgroundColor: '#f8f9fa'
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-section">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group floating-label">
                                                            <input
                                                                type="text"
                                                                id="companyName"
                                                                className="form-control floating-input"
                                                                name="company_name"
                                                                value={formData.company_name}
                                                                onChange={handleSubjectChange}
                                                                placeholder=" "
                                                            />
                                                            <label htmlFor="companyName">Company Name</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group floating-label">
                                                            <input
                                                                type="text"
                                                                id="vatNumber"
                                                                className="form-control floating-input"
                                                                name="vat_number"
                                                                value={formData.vat_number}
                                                                onChange={handleSubjectChange}
                                                                placeholder=" "
                                                            />
                                                            <label htmlFor="vatNumber">VAT Number</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-section">
                                                <h5 className="section-title">
                                                    <i className="bx bx-phone"></i> Contact Information
                                                </h5>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group floating-label">
                                                            <input
                                                                type="email"
                                                                id="companyEmail"
                                                                className="form-control floating-input"
                                                                name="email"
                                                                value={formData.email}
                                                                onChange={handleSubjectChange}
                                                                placeholder=" "
                                                            />
                                                            <label htmlFor="companyEmail">Email Address</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group floating-label">
                                                            <input
                                                                type="text"
                                                                id="companyPhone"
                                                                className="form-control floating-input"
                                                                name="phone"
                                                                value={formData.phone}
                                                                onChange={handleSubjectChange}
                                                                placeholder=" "
                                                            />
                                                            <label htmlFor="companyPhone">Phone Number</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-section">
                                                <h5 className="section-title">
                                                    <i className="bx bx-calendar"></i> Financial Year
                                                </h5>
                                                <div className='row'>
                                                    <div className="col-md-6">
                                                        <div className="form-group floating-label">
                                                            <select
                                                                className="form-control floating-input"
                                                                name="start_fmonth"
                                                                value={formData.start_fmonth || 'january'}
                                                                onChange={handleSubjectChange}
                                                            >
                                                                <option value="">Select Start Month</option>
                                                                {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((month) => (
                                                                    <option key={month} value={month}>{month}</option>
                                                                ))}
                                                            </select>
                                                            <label>Start Month</label>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="form-group floating-label">
                                                            <select
                                                                className="form-control floating-input"
                                                                name="end_fmonth"
                                                                value={formData.end_fmonth || 'december'}
                                                                onChange={handleSubjectChange}
                                                            >
                                                                <option value="">Select End Month</option>
                                                                {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((month) => (
                                                                    <option key={month} value={month}>{month}</option>
                                                                ))}
                                                            </select>
                                                            <label>End Month</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-section">
                                                <h5 className="section-title">
                                                    <i className="bx bx-map"></i> Location Information
                                                </h5>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group floating-label">
                                                            <input
                                                                type="text"
                                                                id="country"
                                                                className="form-control floating-input"
                                                                name="country"
                                                                value={formData.country}
                                                                onChange={handleSubjectChange}
                                                                placeholder=" "
                                                            />
                                                            <label htmlFor="country">Country</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group floating-label">
                                                            <input
                                                                type="text"
                                                                id="zipCode"
                                                                className="form-control floating-input"
                                                                name="ZipCode"
                                                                value={formData.ZipCode}
                                                                onChange={handleSubjectChange}
                                                                placeholder=" "
                                                            />
                                                            <label htmlFor="zipCode">Zip Code</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group floating-label">
                                                            <select
                                                                className='form-control floating-input'
                                                                name="currency"
                                                                value={formData.currency}
                                                                onChange={handleSubjectChange}
                                                            >
                                                                <option value="">Select</option>
                                                                {Array.isArray(countries) &&
                                                                    countries
                                                                        .filter(country =>
                                                                            (country.currency === 'AED' && country.name === 'United Arab Emirates') ||
                                                                            (country.currency === 'USD' && country.name === 'United States')
                                                                        )
                                                                        .sort((a, b) => {
                                                                            const order = ['AED', 'USD'];
                                                                            return order.indexOf(a.currency) - order.indexOf(b.currency);
                                                                        })
                                                                        .map(country => (
                                                                            <option key={country.id} value={country.currency}>
                                                                                {country.currency}
                                                                            </option>
                                                                        ))
                                                                }
                                                                {Array.isArray(countries) &&
                                                                    countries
                                                                        .filter(country =>
                                                                            !(
                                                                                (country.currency === 'AED' && country.name === 'United Arab Emirates') ||
                                                                                (country.currency === 'USD' && country.name === 'United States')
                                                                            )
                                                                        )
                                                                        .map(country => (
                                                                            <option key={country.id} value={country.currency}>
                                                                                {country.currency}
                                                                            </option>
                                                                        ))
                                                                }
                                                            </select>
                                                            <label htmlFor="currency">Currency</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-section">
                                                <h5 className="section-title">
                                                    <i className="bx bx-calendar-week"></i> Working Days
                                                </h5>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <label className="form-label1 mb-3">Select Working Days:</label>
                                                        <div className="working-days-selector">
                                                            {[
                                                                { value: 'sun', label: 'Sunday' },
                                                                { value: 'mon', label: 'Monday' },
                                                                { value: 'tue', label: 'Tuesday' },
                                                                { value: 'wed', label: 'Wednesday' },
                                                                { value: 'thu', label: 'Thursday' },
                                                                { value: 'fri', label: 'Friday' },
                                                                { value: 'sat', label: 'Saturday' }
                                                            ].map((day) => (
                                                                <div className="form-check form-check-inline" key={day.value}>
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`day-${day.value}`}
                                                                        value={day.value}
                                                                        checked={formData.working_days?.includes(day.value)}
                                                                        onChange={(e) => {
                                                                            const isChecked = e.target.checked;
                                                                            setFormData(prev => {
                                                                                const currentDays = prev.working_days || [];
                                                                                let newDays;
                                                                                if (isChecked) {
                                                                                    newDays = [...currentDays, day.value];
                                                                                } else {
                                                                                    newDays = currentDays.filter(d => d !== day.value);
                                                                                }
                                                                                const updated = { ...prev, working_days: newDays };
                                                                                saveFormDataToLocalStorage(updated);
                                                                                return updated;
                                                                            });
                                                                        }}
                                                                    />
                                                                    <label className="form-check-label" htmlFor={`day-${day.value}`}>
                                                                        {day.label}
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <small className="form-text text-muted">
                                                            UAE standard working days are Sunday to Thursday
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-section">
                                                <h5 className="section-title">
                                                    <i className="bx bx-detail"></i> Additional Information
                                                </h5>
                                                <div className="form-group">
                                                    <label className="form-label1">Company Address</label>
                                                    <textarea
                                                        className="form-control textarea-control"
                                                        name="company_address"
                                                        value={formData.company_address}
                                                        onChange={handleSubjectChange}
                                                        rows="3"
                                                    ></textarea>
                                                </div>
                                                <div className="form-group">
                                                    <label className="form-label1">Company Description</label>
                                                    <textarea
                                                        className="form-control textarea-control"
                                                        name="company_info"
                                                        value={formData.company_info}
                                                        onChange={handleSubjectChange}
                                                        rows="3"
                                                    ></textarea>
                                                </div>
                                            </div>

                                            <div className="form-actions">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-save"
                                                    onClick={handleSaveCompanySettings}
                                                >
                                                    <i className="bx bx-save"></i> Save
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    {activeTab === 'smtpSettings' && (
                                        <div className="smtp-settings">
                                            <h5 className="form-title">SMTP Settings</h5>

                                            <div className="form-section">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group floating-label">
                                                            <input
                                                                type="text"
                                                                id="mailMailer"
                                                                className="form-control floating-input"
                                                                name="mail_mailer"
                                                                value={formData.mail_mailer}
                                                                onChange={handleSubjectChange}
                                                                placeholder=" "
                                                            />
                                                            <label htmlFor="mailMailer">Mailer</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group floating-label">
                                                            <input
                                                                type="text"
                                                                id="mailHost"
                                                                className="form-control floating-input"
                                                                name="mail_host"
                                                                value={formData.mail_host}
                                                                onChange={handleSubjectChange}
                                                                placeholder=" "
                                                            />
                                                            <label htmlFor="mailHost">Host</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-section">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group floating-label">
                                                            <input
                                                                type="text"
                                                                id="mailPort"
                                                                className="form-control floating-input"
                                                                name="mail_port"
                                                                value={formData.mail_port}
                                                                onChange={handleSubjectChange}
                                                                placeholder=" "
                                                            />
                                                            <label htmlFor="mailPort">Port</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group floating-label">
                                                            <input
                                                                type="text"
                                                                id="mailEncryption"
                                                                className="form-control floating-input"
                                                                name="mail_encryption"
                                                                value={formData.mail_encryption}
                                                                onChange={handleSubjectChange}
                                                                placeholder=" "
                                                            />
                                                            <label htmlFor="mailEncryption">Encryption</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-section">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group floating-label">
                                                            <input
                                                                type="text"
                                                                id="mailUsername"
                                                                className="form-control floating-input"
                                                                name="mail_username"
                                                                value={formData.mail_username}
                                                                onChange={handleSubjectChange}
                                                                placeholder=" "
                                                            />
                                                            <label htmlFor="mailUsername">Username</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group floating-label">
                                                            <input
                                                                type="password"
                                                                id="mailPassword"
                                                                className="form-control floating-input"
                                                                name="mail_password"
                                                                value={formData.mail_password}
                                                                onChange={handleSubjectChange}
                                                                placeholder=" "
                                                            />
                                                            <label htmlFor="mailPassword">Password</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-section">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group floating-label">
                                                            <input
                                                                type="email"
                                                                id="mailFromAddress"
                                                                className="form-control floating-input"
                                                                name="mail_from_address"
                                                                value={formData.mail_from_address}
                                                                onChange={handleSubjectChange}
                                                                placeholder=" "
                                                            />
                                                            <label htmlFor="mailFromAddress">From Address</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group floating-label">
                                                            <input
                                                                type="text"
                                                                id="mailFromName"
                                                                className="form-control floating-input"
                                                                name="mail_from_name"
                                                                value={formData.mail_from_name}
                                                                onChange={handleSubjectChange}
                                                                placeholder=" "
                                                            />
                                                            <label htmlFor="mailFromName">From Name</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-actions">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-save"
                                                    onClick={handleSaveSettings}
                                                >
                                                    <i className="bx bx-save"></i> Save
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    {activeTab === 'taxSettings' && (
                                        <div className="tax-settings">
                                            <h5 className="form-title">Tax Configuration</h5>
                                            <br />

                                            <div className="card">
                                                <div className="card-body">
                                                    <h5>VAT Quarterly Periods</h5><br />
                                                    {['q1', 'q2', 'q3', 'q4'].map((q, index) => (
                                                        <div className="row mb-4" key={q}>
                                                            <div className="col-md-12 mb-3">
                                                                <strong>{`Q${index + 1}`}</strong>
                                                            </div><br />

                                                            <div className="col-md-4">
                                                                <div className="form-group floating-label">
                                                                    <select
                                                                        className="form-control floating-input"
                                                                        name={`${q}_start_month`}
                                                                        value={formData?.[`${q}_start_month`] || ''}
                                                                        onChange={handleTaxChange}
                                                                    >
                                                                        <option value="">Select Month</option>
                                                                        {months.map((month) => (
                                                                            <option key={month} value={month}>{month}</option>
                                                                        ))}
                                                                    </select>
                                                                    <label>Start Month</label>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <div className="form-group floating-label">
                                                                    <select
                                                                        className="form-control floating-input"
                                                                        name={`${q}_end_month`}
                                                                        value={formData?.[`${q}_end_month`] || ''}
                                                                        onChange={handleTaxChange}
                                                                    >
                                                                        <option value="">Select Month</option>
                                                                        {months.map((month) => (
                                                                            <option key={month} value={month}>{month}</option>
                                                                        ))}
                                                                    </select>
                                                                    <label>End Month</label>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <div className="form-group floating-label">
                                                                    <input
                                                                        type="date"
                                                                        className="form-control floating-input"
                                                                        name={`${q}_due_date`}
                                                                        placeholder="Due Day"
                                                                        value={formData?.[`${q}_due_date`] || ''}
                                                                        onChange={handleTaxChange}
                                                                        min="1"
                                                                        max="31"
                                                                    />
                                                                    <label>Due Day</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}

                                                    <hr className="my-4" />

                                                    <h5>Corporate Tax Settings</h5><br />
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group floating-label">
                                                                <select
                                                                    className="form-control floating-input"
                                                                    name="start_month"
                                                                    value={formData?.start_month || ''}
                                                                    onChange={handleTaxChange}
                                                                >
                                                                    <option value="">Select Month</option>
                                                                    {months.map((month) => (
                                                                        <option key={month} value={month}>{month}</option>
                                                                    ))}
                                                                </select>
                                                                <label>Start Month</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="form-group floating-label">
                                                                <select
                                                                    className="form-control floating-input"
                                                                    name="end_month"
                                                                    value={formData?.end_month || ''}
                                                                    onChange={handleTaxChange}
                                                                >
                                                                    <option value="">Select Month</option>
                                                                    {months.map((month) => (
                                                                        <option key={month} value={month}>{month}</option>
                                                                    ))}
                                                                </select>
                                                                <label>End Month</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="form-group floating-label">
                                                                <input
                                                                    type="date"
                                                                    className="form-control floating-input"
                                                                    name="due_date"
                                                                    placeholder="Due Day"
                                                                    value={formData?.due_date || ''}
                                                                    onChange={handleTaxChange}
                                                                    min="1"
                                                                    max="31"
                                                                />
                                                                <label>Due Day</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-actions mt-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-save"
                                                    onClick={handleSaveTaxSettings}
                                                >
                                                    <i className="bx bx-save"></i> Save
                                                </button>
                                            </div>
                                        </div>
                                    )}




                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
};


export default SettingsDetails;